import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BankStyles from "./BankDetails.module.scss";
import image from "../../Components/assets/Images/bankupdateicon.svg";
import bankIcon from "../../Components/assets/Images/bankpageicon.svg";
import { LoadingButton } from "@mui/lab";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Box,
  Button,
  CircularProgress,
  Fade,
  IconButton,
  Modal,
  Stack,
} from "@mui/material";
import editicon from "../../Components/assets/Images/bankediticon.svg";
import deleteicon from "../../Components/assets/Images/bankdeleteicon.svg";
import upiimageaddbank from "../../Components/assets/Images/upiimageaddbank.svg";
import addmanualimage from "../../Components/assets/Images/addmanualimage.svg";
import closeIcon from "../../Components/assets/Images/closebgicon.svg";
import paymentappsicons from "../../Components/assets/Images/paymentappsicons.svg";
import GpayIcon from "../../Components/assets/Images/gpayicon.svg";
import PhonepeIcon from "../../Components/assets/Images/phonepayicon.svg";
import PaytmIcon from "../../Components/assets/Images/paytmicon.svg";
import Close from "@mui/icons-material/Close";
import AddBankModal from "./AddBankAccountModal/AddBankModal";
import {
  GetBankDetailsBankUpdateAPICall,
  GetModificationsListBankUpdateAPICall,
  GetModificationTypesBankUpdateAPICall,
  GetReversePennyDropStatusAPICall,
  NewReversePennyDropRequestAPICall,
  SecondarytoPrimaryBankUpdateAPICall,
  StageDetailsBankUpdateAPICall,
} from "./BankUpdateAPICalls";
import ModifyBankModal from "./ModifyBankAccountModal/ModifyBankModal";
import keyboardicon from "../../Components/assets/Images/panicongrey.svg";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import SnackBar from "../../Components/SnackBars/SnackBar";
import QRCode from "react-qr-code";
import { isMobile } from "react-device-detect";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

export default function UpdateBankDetails() {
  const navigate = useNavigate();
  const [displayOptions, setDisplayOptions] = useState<any>(null);
  const [loading, setloading] = useState(false);
  const [bankDetails, setBankDetails] = useState([
    {
      id: "",
      micr: "",
      priority: "",
      bank_ifsc: "",
      bank_name: "",
      bank_acc_number: "",
    },
  ]);
  const [agentPlatform, setAgentPlatform] = useState("");
  const [updateModal, setShowUpdateModal] = useState(false);
  const [addModal, setShowAddModal] = useState(false);
  const [updateBankData, setUpdateBankData] = useState<any>();
  const [modificationData, setModificationData] = useState<any>([]);
  const [filteredRequest, setFilteredRequest] = useState([]);
  const [rejectMessage, setRejectMessage] = useState("");
  const [resumeBankDetails, setResumeBankDetails] = useState<any>();
  const [selecttype, setSelectType] = useState(false);
  const [optionSelected, setOptionSelected] = useState(1);
  const [upiMode, setUPIMode] = useState(false);
  const [circularloader, setcircularLoader] = useState(false);
  const [setuDetails, setSetuDetails] = useState({
    id: "",
    // shortUrl: "",
    upiLink: "",
  });
  const [bankDetailsFetched, setBankDetailsFetched] = useState<any>({
    accountType: "",
    bankAccountIfsc: "",
    bankAccountName: "",
    bankAccountNumber: "",
    payerVpa: "",
    ifscDetails: { address: "", branch: "", micr: "", name: "" },
  });
  const [upiID, setUpiId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const pollingIntervalRef = useRef<any>(null);
  const upiWindowRef = useRef<Window | null>(null);
  const upiWindowCloseIntervalRef = useRef<number | null>(null);

  const closeUPIWindow = React.useCallback(() => {
    if (upiWindowCloseIntervalRef.current !== null) {
      window.clearInterval(upiWindowCloseIntervalRef.current);
      upiWindowCloseIntervalRef.current = null;
    }
    if (upiWindowRef.current && !upiWindowRef.current.closed) {
      upiWindowRef.current.close();
    }
    // setUPIMode(false);
    upiWindowRef.current = null;

    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    GetBankDetails();
    GetModificationsDetails();
    GetModificationsTypes();

    const userAgent = navigator.userAgent.toLowerCase();

    if (/iphone|ipad|ipod/.test(userAgent)) {
      setAgentPlatform("iOS");
    } else if (/android/.test(userAgent)) {
      setAgentPlatform("Android");
    } else {
      setAgentPlatform("Other");
    }
  }, []);

  useEffect(() => {
    return () => {
      closeUPIWindow();
    };
  }, [closeUPIWindow]);

  useEffect(() => {
    if (modificationData) {
      const filteredRequestData: any = modificationData?.filter(
        (a: any) =>
          a.status === "PENDING" ||
          a.status === "COMPLETED" ||
          a.status === "REJECTED",
      );
      setFilteredRequest(filteredRequestData);
    }
    if (modificationData && modificationData[0]) {
      StageDetails();
    }
  }, [modificationData]);

  const StageDetails = () => {
    let obj: any = {
      request_id: modificationData[0]?.req_id,
      stage_name: "esign",
    };

    StageDetailsBankUpdateAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        if (response.data.data.ErrMessage) {
          setRejectMessage(response.data.data.ErrMessage);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };
  const GetBankDetails = () => {
    GetBankDetailsBankUpdateAPICall()
      .then((response: any) => {
        if (response.data?.data?.existing_bank_details) {
          setBankDetails(response.data.data.existing_bank_details);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const GetModificationsDetails = () => {
    GetModificationsListBankUpdateAPICall()
      .then((response: any) => {
        if (response.data?.data && response.data?.data.bank_details?.length) {
          const filtred = response.data?.data.bank_details?.filter(
            (a: any) => a.category !== "",
          );
          setModificationData(filtred);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };
  const GetModificationsTypes = () => {
    GetModificationTypesBankUpdateAPICall()
      .then((response: any) => {})
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const handleResume = (rowdata: any) => {
    if (rowdata.category === "Secondary to Primary Bank Modification") {
      sessionStorage.setItem("reqId", rowdata.req_id);
      navigate("/bankupdate/esign");
    } else {
      setBankDetailsFetched({
        accountType: "",
        bankAccountIfsc: rowdata?.bank_details?.ifsc,
        bankAccountName: rowdata?.bank_details?.customer_name,
        bankAccountNumber: rowdata?.bank_details?.account_no,
        payerVpa: rowdata?.bank_details?.upi,
        ifscDetails: {
          address: "",
          branch: "",
          micr: "",
          name: rowdata?.bank_details?.bank_name,
        },
      });
      if (rejectMessage !== "") {
        setSelectType(true);
        sessionStorage.setItem("reqId", rowdata.req_id);
      } else {
        if (rowdata?.bank_details?.upi === "") {
          setOptionSelected(2);
        } else {
          setOptionSelected(1);
        }
        setShowAddModal(true);
        setResumeBankDetails(rowdata.bank_details);
        sessionStorage.setItem("reqId", rowdata.req_id);
      }
    }
    // navigate("/updates/bankupdate/esign");
  };

  const handleCloseModifyModal = () => {
    setShowUpdateModal(false);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };

  const SecondarytoPrimaryBank = (details: any) => {
    let obj: any = {
      new_primary_acc_no: details.account_no,
      request_id: null,
    };
    SecondarytoPrimaryBankUpdateAPICall(obj)
      .then((response: any) => {
        sessionStorage.setItem("reqId", response.data.data.request_id);
        navigate("/bankupdate/esign");
      })
      .catch((error: any) => {});
  };

  const getReversePennyDropStatus = (setu_id: any) => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    console.log("setu_id", setu_id);
    pollingIntervalRef.current = setInterval(() => {
      GetReversePennyDropStatusAPICall({ penny_drop_id: setu_id })
        .then((response: any) => {
          const responseData = response.data;

          // console.log("responseData", responseData.data.data === null);
          if (responseData?.data?.data !== null) {
            // setStatusError("200, Data  received");
            if (pollingIntervalRef.current) {
              clearInterval(pollingIntervalRef.current);
            }
            if (responseData?.data?.data?.ifscCrossCheck === true) {
              setShowAddModal(true);
              setUPIMode(false);
              closeUPIWindow();
              setBankDetailsFetched(responseData?.data?.data);
              setUpiId(responseData?.data?.data?.payerVpa);
              // toast.custom(
              //   <Snackbar type="s" msg={"Bank Details Fetched Successfully"} />,
              // );
            } else if (responseData?.data?.data?.ifscCrossCheck === false) {
              setShowAddModal(true);
              setUPIMode(false);
              closeUPIWindow();

              setErrorMessage(
                "Error Fetching Bank Details, Enter Details Manually",
              );
              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          } else {
            // setStatusError("200, Data not received");
          }
        })
        .catch((error: any) => {
          // setStatusError(`"400, Failed"${JSON.stringify(error?.code)}`);
          if (error?.code !== "ERR_BAD_REQUEST") {
            getReversePennyDropStatus(setu_id);
          } else {
            setUPIMode(false);
            closeUPIWindow();

            setErrorMessage(
              error?.response?.data?.message
                ? error?.response?.data?.message
                : "Transaction failed",
            );
            setTimeout(() => {
              setErrorMessage("");
            }, 5000);
            if (pollingIntervalRef.current) {
              clearInterval(pollingIntervalRef.current);
            }
          }
        });
    }, 2000);
  };

  const handleContinuewithUPI = () => {
    window.scrollTo(0, 0);
    setcircularLoader(true);
    setUPIMode(true);
    NewReversePennyDropRequestAPICall({})
      .then((response: any) => {
        setcircularLoader(false);
        const responseData = response.data;
        //console.log("responseData", responseData);
        if (responseData?.data?.id) {
          if (!isMobile) {
            closeUPIWindow();
            upiWindowRef.current = window.open(
              responseData?.data?.upiLink,
              "reversePennyDropUPI",
              "popup=yes,width=500,height=700",
            );
            if (upiWindowRef.current) {
              upiWindowCloseIntervalRef.current = window.setInterval(() => {
                if (upiWindowRef.current?.closed) {
                  closeUPIWindow();
                  setUPIMode(false);
                }
              }, 500);
            } else {
              setUPIMode(false);
              setErrorMessage(
                "Pop-up blocked. Please allow pop-ups in your browser and try again.",
              );
              setTimeout(() => {
                setErrorMessage("");
              }, 5000);
            }
          }

          setSetuDetails({
            id: responseData?.data?.id,
            // shortUrl: responseData?.data?.shortUrl,
            upiLink: responseData?.data?.upiLink,
          });
          getReversePennyDropStatus(responseData?.data?.id);
        }
      })
      .catch((error: any) => {
        //  console.log("error", error);
      });
  };

  const handleContinueManually = () => {
    setShowAddModal(true);
  };

  return (
    <>
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      {selecttype ? (
        <div className={BankStyles.mainWrapper}>
          <div className={BankStyles.wrapper}>
            <div className={BankStyles.step}>
              <img src={keyboardicon} /> Step 3 of 4
            </div>
            <div>
              <p className={BankStyles.Header}>Link Your Bank Account</p>
            </div>
            <p className={BankStyles.subText}>
              Add your primary bank account for trading transactions.
            </p>
          </div>
          <div className={BankStyles.selectionWrapper}>
            <div className={BankStyles.selections}>
              <div
                className={BankStyles.selectionItem}
                style={{
                  border: optionSelected === 1 ? "1px solid #111827" : "",
                }}
                onClick={() => {
                  setOptionSelected(1);
                }}
              >
                <img src={upiimageaddbank} alt="" />
                <div className={BankStyles.right}>
                  <div className={BankStyles.text}>
                    Verify Bank Account Instantly{" "}
                  </div>
                  <div className={BankStyles.text2}>
                    We’ll debit ₹1 for verification and refund it after
                    completion.
                  </div>
                </div>
              </div>
              <div
                className={BankStyles.selectionItem}
                style={{
                  border: optionSelected === 2 ? "1px solid #111827" : "",
                }}
                onClick={() => {
                  setOptionSelected(2);
                }}
              >
                <img src={addmanualimage} alt="" />
                <div className={BankStyles.right}>
                  <div className={BankStyles.text}>Add details manually </div>
                  <div className={BankStyles.text2}>
                    Enter your bank name, account number, and IFSC code.
                  </div>
                </div>
              </div>
            </div>

            <div className={BankStyles.buttonsWrap}>
              <LoadingButton
                loading={loading}
                variant="outlined"
                type="submit"
                id="linkUsingIFSCContinueButton"
                className={BankStyles.backButton}
                disableTouchRipple
                disableElevation
                disableFocusRipple
                sx={{
                  height: "50px",
                  fontSize: "14px",
                  color: "var(--text-primary)",
                  fontWeight: 500,
                  background: "var(--background-secondary)",
                  // "&:hover":{
                  //   background: "var(--hover-secondary)",
                  // }

                  marginRight: "20px",
                }}
                onClick={() => {
                  GetModificationsDetails();
                  setSelectType(false);
                }}
              >
                Back
              </LoadingButton>
              {optionSelected === 1 ? (
                <LoadingButton
                  variant="contained"
                  type="submit"
                  id="linkUsingIFSCContinueButton"
                  className={BankStyles.continuebutton}
                  onClick={handleContinuewithUPI}
                  sx={{ height: "50px" }}
                >
                  Continue
                </LoadingButton>
              ) : (
                <LoadingButton
                  variant="contained"
                  type="submit"
                  id="linkUsingIFSCContinueButton"
                  className={BankStyles.continuebutton}
                  onClick={handleContinueManually}
                  sx={{ height: "50px" }}
                >
                  Continue
                </LoadingButton>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={BankStyles.mainWrapper}>
          <div className={BankStyles.wrapper}>
            <div className={BankStyles.step}>
              <img src={keyboardicon} /> Step 2 of 4
            </div>
            <div>
              <p className={BankStyles.Header}>Bank Details</p>
            </div>
            <p className={BankStyles.subText}>
              View your Bank information below for confirmation
            </p>
          </div>
          <div className={BankStyles.bankDetailsWrapper}>
            <p className={BankStyles.bankAccountText}>Your Bank Accounts</p>

            <div className={BankStyles.accountDetailsSection}>
              {bankDetails.map((a: any, index: any) => (
                <div className={BankStyles.accountDetails}>
                  <div className={BankStyles.titleName}>
                    <p className={BankStyles.title}>Registered Bank</p>
                    <p className={BankStyles.data}>{a.name}</p>
                  </div>
                  <div className={BankStyles.divider}></div>
                  <div className={BankStyles.titleName}>
                    <p className={BankStyles.title}>Account Number</p>
                    <p className={BankStyles.data}>{a.account_no}</p>
                  </div>
                  <div className={BankStyles.divider}></div>
                  <div className={BankStyles.titleName}>
                    <p className={BankStyles.title}>IFSC Code</p>
                    <p className={BankStyles.data}>{a.ifsc}</p>
                  </div>
                  {a.priority !== "1" && (
                    <div className={BankStyles.actionSection}>
                      <IconButton
                        onClick={() => {
                          if (displayOptions === a) {
                            setDisplayOptions(null);
                          } else {
                            setDisplayOptions(a);
                          }
                        }}
                      >
                        {displayOptions === a ? (
                          <Close style={{ color: "#000" }} />
                        ) : (
                          <MoreVertIcon style={{ color: "#000" }} />
                        )}
                      </IconButton>
                      {displayOptions === a && (
                        <div className={BankStyles.updateDeleteSection}>
                          <div
                            className={BankStyles.update}
                            onClick={() => {
                              SecondarytoPrimaryBank(a);
                            }}
                          >
                            <img src={editicon} /> <span>Set Primary</span>
                          </div>
                          {/* <div className={BankStyles.delete}>
                        <img src={deleteicon} /> <span>Delete</span>
                      </div> */}
                        </div>
                      )}
                    </div>
                  )}
                  {a.priority === "1" && (
                    <div className={BankStyles.primary}>Primary</div>
                  )}
                </div>
              ))}
            </div>

            <div className={BankStyles.buttonStack}>
              {!filteredRequest[0] && (
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  type="submit"
                  id="linkUsingIFSCContinueButton"
                  className={BankStyles.approveButton}
                  sx={{
                    fontSize: "12px",
                    marginTop: "10px",
                    padding: "8px 30px",
                    height: "45px",
                  }}
                  onClick={() => {
                    setSelectType(true);
                  }}
                >
                  Add Bank Account
                </LoadingButton>
              )}
            </div>
          </div>

          {modificationData?.length > 0 && (
            <>
              <div className={BankStyles.updateStatus}>
                <p className={BankStyles.recentModifiedText}>
                  Recent Modification
                </p>

                <div className={BankStyles.tableWrapper}>
                  <div className={BankStyles.header}>
                    <div className={BankStyles.headerCellCategory}>
                      Category
                    </div>
                    <div className={BankStyles.headerCellStatus}>Status</div>
                    <div className={BankStyles.headerCellMessage}>
                      Created at
                    </div>

                    <div className={BankStyles.headerCellAction}>Action</div>
                  </div>

                  <div className={BankStyles.dataContainer}>
                    {modificationData &&
                      modificationData?.map((a: any) => (
                        <div className={BankStyles.tableData}>
                          <div className={BankStyles.dataCellCategory}>
                            {a?.category}
                          </div>
                          <div className={BankStyles.dataCellStatus}>
                            {a?.status}
                          </div>
                          <div className={BankStyles.dataCelllastreject}>
                            {a?.created_on}
                          </div>

                          <div className={BankStyles.dataCellAction}>
                            {a?.status === "PENDING" && (
                              <div
                                className={BankStyles.resumeButton}
                                onClick={() => {
                                  handleResume(a);
                                }}
                              >
                                Resume
                              </div>
                            )}
                            {a?.status === "REJECTED" && (
                              <div
                                className={BankStyles.resumeButton}
                                onClick={() => {
                                  handleResume(a);
                                }}
                              >
                                Resume
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className={BankStyles.updateStatusMobile}>
                <p className={BankStyles.recentModifiedText}>
                  Recent Modification
                </p>
                {modificationData?.map((a: any) => (
                  <div className={BankStyles.updateStatusMobileContent}>
                    <div className={BankStyles.mobileDiv}>
                      <p className={BankStyles.mobileDivHeader}>Category:</p>
                      <p className={BankStyles.mobileDivContent}>
                        {a.category}
                      </p>
                    </div>
                    <div className={BankStyles.mobileDiv}>
                      <p className={BankStyles.mobileDivHeader}>Status :</p>
                      <p className={BankStyles.mobileDivContent}>{a.status}</p>
                    </div>
                    <div className={BankStyles.mobileDiv}>
                      <p className={BankStyles.mobileDivHeader}>Created at :</p>
                      <p className={BankStyles.mobileDivContent}>
                        {a.created_on}
                      </p>
                    </div>
                    <div className={BankStyles.mobileDivresume}>
                      {a?.status === "PENDING" && (
                        <div
                          className={BankStyles.resumeButton}
                          onClick={() => {
                            handleResume(a);
                          }}
                        >
                          Resume
                        </div>
                      )}
                      {a?.status === "REJECTED" && (
                        <div
                          className={BankStyles.resumeButton}
                          onClick={() => {
                            handleResume(a);
                          }}
                        >
                          Resume
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>{" "}
            </>
          )}
        </div>
      )}

      {addModal && (
        <AddBankModal
          showModal={addModal}
          handleCloseModifyModal={handleCloseAddModal}
          resumeBankDetails={resumeBankDetails}
          bankDetailsFetched={bankDetailsFetched}
          optionSelected={optionSelected}
        />
      )}
      {updateModal && (
        <ModifyBankModal
          showModal={updateModal}
          handleCloseModifyModal={handleCloseModifyModal}
          bankData={updateBankData}
        />
      )}

      {upiMode && (
        <>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={upiMode}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={upiMode}>
              <Box className={BankStyles.boxModalWrapper}>
                <div className={BankStyles.modalWrapper}>
                  <div
                    className={BankStyles.closebutton}
                    onClick={() => {
                      setUPIMode(false);
                      if (pollingIntervalRef.current) {
                        clearInterval(pollingIntervalRef.current);
                      }
                    }}
                  >
                    <img src={closeIcon} alt="" />
                  </div>
                  <div className={BankStyles.wrapperUpi}>
                    <p className={BankStyles.Header}>Pay with UPI</p>

                    <p className={BankStyles.subText}>
                      Debited Amount ₹1 will be credited within 2 working days
                    </p>
                  </div>
                  <div>
                    <div className={BankStyles.desktopIframe}>
                      {/* {circularloader && ( */}
                      <Stack
                        height={"40vh"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        direction={"row"}
                        width={"100%"}
                      >
                        <CircularProgress />
                      </Stack>
                      {/* )} */}
                    </div>
                    {/* {!circularloader && (
                      <>
                        <div className={BankStyles.desktopIframe}>
                          <div className={BankStyles.qrpayamount}>₹1.00</div>
                          <div className={BankStyles.qrpaydesc}>
                            Scan QR code with any UPI app
                          </div>

                          <div className={BankStyles.qr}>
                            <QRCode
                              size={256}
                              style={{ height: "172px", width: "172px" }}
                              value={setuDetails.upiLink}
                              viewBox={`0 0 256 256`}
                            />
                          </div>
                        </div>
                        <div className={BankStyles.imgwrapper}>
                          <img
                            src={paymentappsicons}
                            alt="apps"
                            className={BankStyles.qrapps}
                          />
                        </div>
                      </>
                    )} */}

                    <div className={BankStyles.mobileUpiLink}>
                      {circularloader && (
                        <Stack
                          height={"50vh"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          direction={"row"}
                          width={"100%"}
                        >
                          <CircularProgress />
                        </Stack>
                      )}
                      {!circularloader && (
                        <>
                          {/* {agentPlatform === "iOS" ? ( */}
                          <>
                            <div className={BankStyles.iosPaymentUI}>
                              <div className={BankStyles.iosPaymentUItop}>
                                <div className={BankStyles.paymentText}>
                                  Payment Amount
                                </div>
                                <div className={BankStyles.paymentAmount}>
                                  ₹1.00
                                </div>
                                <div className={BankStyles.paymentText}>
                                  Secure UPI verification
                                </div>
                              </div>
                              <p className={BankStyles.selectText}>Pay With</p>

                              {!circularloader && (
                                <div
                                  className={BankStyles.paymentsOptionsSction}
                                >
                                  <a
                                    // href={setuDetails.upiLink?.replace(
                                    //   "upi://pay",
                                    //   "phonepe://pay",
                                    // )}
                                    href={`${setuDetails.upiLink}?app=phonepe`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                      width: "33%",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={PhonepeIcon} />
                                      <p>PhonePe</p>
                                    </div>
                                  </a>
                                  <a
                                    // href={setuDetails.upiLink?.replace(
                                    //   "upi://pay",
                                    //   "gpay://upi/pay",
                                    // )}
                                    href={`${setuDetails.upiLink}?app=gpay`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                      width: "33%",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={GpayIcon} />
                                      <p>GPay</p>
                                    </div>
                                  </a>
                                  <a
                                    // href={setuDetails.upiLink?.replace(
                                    //   "upi://pay",
                                    //   "paytmmp://pay",
                                    // )}
                                    href={`${setuDetails.upiLink}?app=paytm`}
                                    style={{
                                      textDecoration: "none",
                                      color: "black",
                                      width: "33%",
                                    }}
                                  >
                                    <div className={BankStyles.paymentOptions}>
                                      <img src={PaytmIcon} />
                                      <p>PayTM</p>
                                    </div>
                                  </a>
                                </div>
                              )}
                            </div>
                          </>
                          {/* ) : (
                            <div style={{ width: "100%" }}>
                              <div className={BankStyles.iosPaymentUItop}>
                                <div className={BankStyles.paymentText}>
                                  Payment Amount
                                </div>
                                <div className={BankStyles.paymentAmount}>
                                  ₹1.00
                                </div>
                                <div className={BankStyles.paymentText}>
                                  Secure UPI verification
                                </div>
                              </div>

                              <div
                                className={BankStyles.buttonStack}
                                style={{ width: "cal(100% - 10px)" }}
                              >
                                <a
                                  href={setuDetails.upiLink}
                                  className={BankStyles.upiLink}
                                >
                                  <Button
                                    variant="contained"
                                    sx={{ width: "187px" }}
                                    // onClick={handleMobilePaymentLink}
                                  >
                                    Pay Rs.1
                                  </Button>
                                </a>
                              </div>
                            </div>
                          )} */}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </Box>
            </Fade>
          </Modal>
        </>
      )}
    </>
  );
}
